import type { Question } from "../Questions";

export const carrierBuildQuestionsV4: Question[] = [
	{
		order: 1,
		key: "1_MillBuilding.Date",
		text: "Date",
		type: "date",
		nextQuestion: "2_MillBuilding.Shift",
	},
	{
		order: 2,
		key: "2_MillBuilding.Shift",
		text: "Shift",
		type: "options",
		options: ["A", "B", "C", "D"],
		nextQuestion: "3_MillBuilding.IDNumber",
	},
	{
		order: 3,
		key: "3_MillBuilding.IDNumber",
		text: "ID Number",
		type: "number",
		nextQuestion: "4_MillBuilding.Section",
	},
	{
		order: 4,
		key: "4_MillBuilding.Section",
		text: "Section",
		type: "section",
		nextQuestion: "11_MillBuilding.StandNumber",
	},
	{
		order: 5,
		key: "11_MillBuilding.StandNumber",
		text: "Stand Number",
		type: "stand",
		dependsOnKey: "10_MillBuilding.FinishStand",
		nextQuestion: {
			Universal: "RollsetId",
			Edger: "7_MillBuilding.FullBodyType",
		},
	},
	{
		order: 6,
		key: "7_MillBuilding.FullBodyType",
		text: "Type of Full Body",
		type: "options",
		options: ["Horizontal", "Diagonal"],
		nextQuestion: "8_MillBuilding.ChockSize",
	},
	{
		order: 7,
		key: "8_MillBuilding.ChockSize",
		text: "Chock Size",
		type: "options",
		options: ["Short", "Tall"],
		nextQuestion: {
			Short: "9_MillBuilding.ShortChockBait",
			Tall: "RollsetId",
		},
	},
	{
		order: 8,
		key: "9_MillBuilding.ShortChockBait",
		text: 'If "short chock" is being used on a full body, has 1-1/2" of bait been added?',
		type: "boolean",
		nextQuestion: "RollsetId",
	},
	{
		order: 9,
		key: "RollsetId",
		text: "Rollset",
		type: "rollset",
		nextQuestion: "49_Passes.RollsPass",
	},
	{
		order: 10,
		key: "49_Passes.RollsPass",
		text: "Rolls Pass",
		type: "rollsPass",
		nextQuestion: "15_MillBuilding.SetBait",
	},
	{
		order: 11,
		key: "15_MillBuilding.SetBait",
		text: "Set Bait",
		type: "number",
		nextQuestion: "19_MillBuilding.CheckBaitMeasurement",
	},
	{
		order: 12,
		key: "19_MillBuilding.CheckBaitMeasurement",
		text: "Check bait from bottom of chock to the floor of mill stand. Are both sides the same measurement?",
		type: "boolean",
		nextQuestion: "20_MillBuilding.RecordMeasurement",
	},
	{
		order: 13,
		key: "20_MillBuilding.RecordMeasurement",
		text: "A. Record Riverside Bait Measurement",
		type: "text",
		nextQuestion: "50_MillBuilding.RecordMeasurement",
		numberGroup: "baitMeasurement",
	},
	{
		order: 14,
		key: "50_MillBuilding.RecordMeasurement",
		text: "B. Record Avenue Side Bait Measurement",
		type: "text",
		nextQuestion: "17_MillBuilding.BottomWaterPipes",
		numberGroup: "baitMeasurement",
	},
	{
		order: 15,
		key: "17_MillBuilding.BottomWaterPipes",
		text: "Are the bottom water pipes the correct size, secured, and in operational condition?",
		type: "boolean",
		nextQuestion: "18_MillBuilding.SetBottomRoll",
	},
	{
		order: 16,
		key: "18_MillBuilding.SetBottomRoll",
		text: "Set bottom roll?",
		type: "boolean",
		nextQuestion: "21_MillBuilding.SetCassetteHousing",
	},
	{
		order: 17,
		key: "21_MillBuilding.SetCassetteHousing",
		text: "Set cassette housing",
		type: "boolean",
		nextQuestion: "22_MillBuilding.SetApex",
	},
	{
		order: 18,
		key: "22_MillBuilding.SetApex",
		text: "Set Apex",
		type: "boolean",
		nextQuestion: "23_MillBuilding.CassetteHousingTight",
	},
	{
		order: 19,
		key: "23_MillBuilding.CassetteHousingTight",
		text: "Cassette housing tight, using knocker wrench?",
		type: "boolean",
		nextQuestion: "24_MillBuilding.CassetteWaterAirLines",
	},
	{
		order: 20,
		key: "24_MillBuilding.CassetteWaterAirLines",
		text: "Cassette water and air oil lines tight?",
		type: "boolean",
		nextQuestion: "25_MillBuilding.SetTopRoll",
	},
	{
		order: 21,
		key: "25_MillBuilding.SetTopRoll",
		text: "Set top roll",
		type: "boolean",
		nextQuestion: "26_MillBuilding.RollsLinedUp",
	},
	{
		order: 22,
		key: "26_MillBuilding.RollsLinedUp",
		text: "Rolls lined up?",
		type: "boolean",
		nextQuestion: "27_MillBuilding.TurnbucklesTight",
	},
	{
		order: 23,
		key: "27_MillBuilding.TurnbucklesTight",
		text: "Turnbuckles tight and locked down?",
		type: "boolean",
		nextQuestion: "28_MillBuilding.SetBottomGuides",
	},
	{
		order: 24,
		key: "28_MillBuilding.SetBottomGuides",
		text: "Set bottom guides.",
		type: "boolean",
		nextQuestion: "29_MillBuilding.TopWaterPipe",
	},
	{
		order: 25,
		key: "29_MillBuilding.TopWaterPipe",
		text: "Top water pipe: inspected and installed?",
		type: "boolean",
		nextQuestion: "30_MillBuilding.BottomGuidesSprings",
	},
	{
		order: 26,
		key: "30_MillBuilding.BottomGuidesSprings",
		text: "Springs installed on bottom guides?",
		type: "boolean",
		nextQuestion: "31_MillBuilding.BottomGuideBubbleLevel",
	},
	{
		order: 27,
		key: "31_MillBuilding.BottomGuideBubbleLevel",
		text: "Is bottom guide set 1/2 bubble low?",
		type: "boolean",
		nextQuestion: "32_MillBuilding.SetTopGuides",
	},
	{
		order: 28,
		key: "32_MillBuilding.SetTopGuides",
		text: "Set top guides.",
		type: "boolean",
		nextQuestion: "33_MillBuilding.TopGuidesSprings",
	},
	{
		order: 29,
		key: "33_MillBuilding.TopGuidesSprings",
		text: "Springs installed on top guides?",
		type: "boolean",
		nextQuestion: "34_MillBuilding.GuidesParting",
	},
	{
		order: 30,
		key: "34_MillBuilding.GuidesParting",
		text: 'Set parting between guides, thickness of the web PLUS 1/16".',
		type: "boolean",
		nextQuestion: "35_MillBuilding.SetDelivery",
	},
	{
		order: 31,
		key: "35_MillBuilding.SetDelivery",
		text: "Set delivery.",
		type: "boolean",
		nextQuestion: "36_MillBuilding.DeliveryTight",
	},
	{
		order: 32,
		key: "36_MillBuilding.DeliveryTight",
		text: "Is the delivery tight?",
		type: "boolean",
		nextQuestion: "37_MillBuilding.DeliveryWidth",
	},
	{
		order: 33,
		key: "37_MillBuilding.DeliveryWidth",
		text: "Inside width measurement of Delivery:",
		type: "text",
		nextQuestion: "38_MillBuilding.DeliveryHoldDownClip",
	},
	{
		order: 34,
		key: "38_MillBuilding.DeliveryHoldDownClip",
		text: "Is the delivery hold down clip bottomed out against the rest bar?",
		type: "boolean",
		nextQuestion: "39_MillBuilding.SetEntry",
	},
	{
		order: 35,
		key: "39_MillBuilding.SetEntry",
		text: "Set entry.",
		type: "boolean",
		nextQuestion: "40_MillBuilding.EntryTight",
	},
	{
		order: 36,
		key: "40_MillBuilding.EntryTight",
		text: "Is the entry tight?",
		type: "boolean",
		nextQuestion: "41_MillBuilding.EntryWidth",
	},
	{
		order: 37,
		key: "41_MillBuilding.EntryWidth",
		text: "Inside width measurement of Entry box:",
		type: "text",
		nextQuestion: "42_MillBuilding.EntryHoldDownClip",
	},
	{
		order: 38,
		key: "42_MillBuilding.EntryHoldDownClip",
		text: "Is the entry hold down clip bottomed out against the rest bar?",
		type: "boolean",
		nextQuestion: "43_MillBuilding.EntryBlockedWithWood",
	},
	{
		order: 39,
		key: "43_MillBuilding.EntryBlockedWithWood",
		text: "Is the entry blocked in with wood?",
		type: "boolean",
		nextQuestion: "44_MillBuilding.CassetteParting",
	},
	{
		order: 40,
		key: "44_MillBuilding.CassetteParting",
		text: 'Set cassette 1/8" larger than parting?',
		type: "boolean",
		nextQuestion: "45_MillBuilding.StandIdentification",
	},
	{
		order: 41,
		key: "45_MillBuilding.StandIdentification",
		text: "Is Mill Stand properly identified with Stand Number? (Chalk on upright)",
		type: "boolean",
		nextQuestion: "46_MillBuilding.EmployeeClockNumbers",
	},
	{
		order: 42,
		key: "46_MillBuilding.EmployeeClockNumbers",
		text: "Clock number of employees that built mill.",
		type: "number",
		nextQuestion: "47_MillBuilding.ForemanName",
	},
	{
		order: 43,
		key: "47_MillBuilding.ForemanName",
		text: "Name of Mill build Foreman that performed inspection:",
		type: "text",
		nextQuestion: "48_MillBuilding.Housekeeping",
	},
	{
		order: 44,
		key: "48_MillBuilding.Housekeeping",
		text: "Housekeeping",
		type: "options",
		options: ["Excellent", "Good", "Fair", "Poor"],
		nextQuestion: null,
	},
];
